module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiselect",
    class: {
      'multiselect--active': _vm.isOpen,
      'multiselect--disabled': _vm.disabled,
      'multiselect--above': _vm.isAbove,
    },
    attrs: {
      "tabindex": _vm.searchable ? -1 : _vm.tabindex
    },
    on: {
      "focus": function($event) {
        _vm.activate()
      },
      "blur": function($event) {
        _vm.searchable ? false : _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.deactivate()
      }
    }
  }, [_vm._t("caret", [_c('div', {
    staticClass: "multiselect__select",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggle()
      }
    }
  })], {
    toggle: _vm.toggle
  }), _vm._v(" "), _vm._t("clear", null, {
    search: _vm.search
  }), _vm._v(" "), _c('div', {
    ref: "tags",
    staticClass: "multiselect__tags"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleValues.length > 0),
      expression: "visibleValues.length > 0"
    }],
    staticClass: "multiselect__tags-wrap"
  }, [_vm._l((_vm.visibleValues), function(option, index) {
    return [_vm._t("tag", [_c('span', {
      key: index,
      staticClass: "multiselect__tag"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getOptionLabel(option))
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "multiselect__tag-icon",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          _vm.removeElement(option)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.removeElement(option)
        }
      }
    })])], {
      option: option,
      search: _vm.search,
      remove: _vm.removeElement
    })]
  })], 2), _vm._v(" "), (_vm.internalValue && _vm.internalValue.length > _vm.limit) ? [_vm._t("limit", [_c('strong', {
    staticClass: "multiselect__strong",
    domProps: {
      "textContent": _vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))
    }
  })])] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect__loading"
    }
  }, [_vm._t("loading", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "multiselect__spinner"
  })])], 2), _vm._v(" "), (_vm.searchable) ? _c('input', {
    ref: "search",
    class: _vm.showInput ? 'multiselect__input' : 'multiselect_input',
    style: (_vm.inputStyle),
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "tabindex": _vm.tabindex
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function($event) {
        _vm.updateSearch($event.target.value)
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.activate()
      },
      "blur": function($event) {
        $event.preventDefault();
        _vm.deactivate()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) { return null; }
        $event.stopPropagation();
        _vm.removeLastElement()
      }]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSingleLabelVisible) ? _c('span', {
    staticClass: "multiselect__single",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_vm._t("singleLabel", [
    [_vm._v(_vm._s(_vm.currentOptionLabel))]
  ], {
    option: _vm.singleValue
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isPlaceholderVisible) ? _c('span', {
    staticClass: "multiselect__placeholder",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_vm._t("placeholder", [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n      ")])], 2) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "list",
    staticClass: "multiselect__content-wrapper",
    style: ({
      maxHeight: _vm.optimizedHeight + 'px'
    }),
    on: {
      "focus": _vm.activate,
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "multiselect__content",
    class: {
      multiselect__collapsible: _vm.groupCollapsible
    },
    style: (_vm.contentStyle)
  }, [_vm._t("beforeList"), _vm._v(" "), (_vm.multiple && _vm.max === _vm.internalValue.length) ? _c('li', [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("maxElements", [_vm._v("Maximum of " + _vm._s(_vm.max) + " options selected. First remove a selected\n              option to select another.")])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.max || _vm.internalValue.length < _vm.max) ? _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "multiselect__element",
      class: {
        'multiselect__collapsible-group':
        _vm.groupCollapsible && option.$isLabel,
          'multiselect__collapsible-expanded':
          _vm.groupCollapsible && _vm.isGroupCollapsibleOptionExpanded(option),
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.groupCollapsibleToggle(option)
        }
      }
    }, [(option.$isLabel) ? _vm._t("caret-collapsible", [_c('div', {
      staticClass: "multiselect__collapsible-toggle-icon",
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.groupCollapsibleToggle(option, true)
        }
      }
    })], {
      toggle: _vm.groupCollapsibleToggle
    }) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "collapsible-slide-toggle"
      }
    }, [(!_vm.groupCollapsible ||
      option.$isLabel ||
      _vm.isGroupCollapsibleOptionExpanded(option)
    ) ? _c('div', [(!(option && (option.$isLabel || option.$isDisabled))) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.optionHighlight(index, option),
      attrs: {
        "data-select": option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.deselectLabelText,
        "data-collapsed": _vm.collapsedGroupLabelText,
        "data-expanded": _vm.expandedGroupLabelText
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(option)
        },
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.pointerSet(index)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e(), _vm._v(" "), (option && (option.$isLabel || option.$isDisabled)) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.groupHighlight(index, option),
      attrs: {
        "data-select": _vm.groupSelect && _vm.selectGroupLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.groupSelect && _vm.deselectGroupLabelText,
        "data-collapse": _vm.groupCollapsible ? _vm.expandedGroupLabelText : '',
        "data-expand": _vm.groupCollapsible ? _vm.collapsedGroupLabelText : ''
      },
      on: {
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.groupSelect && _vm.pointerSet(index)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.selectGroup(option)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e()]) : _vm._e()])], 2)
  }) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.showNoResults &&
        _vm.filteredOptions.length === 0 &&
        _vm.search &&
        !_vm.loading
      ),
      expression: "\n            showNoResults &&\n            filteredOptions.length === 0 &&\n            search &&\n            !loading\n          "
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noResult", [_vm._v("No elements found. Consider changing the search query.")])], 2)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.showNoOptions && _vm.options.length === 0 && !_vm.search && !_vm.loading
      ),
      expression: "\n            showNoOptions && options.length === 0 && !search && !loading\n          "
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noOptions", [_vm._v("List is empty.")])], 2)]), _vm._v(" "), _vm._t("afterList")], 2)])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7861fdcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js-on/vue-multiselect/Multiselect.vue
// module id = 972
// module chunks = 0